export default __webpack_public_path__ + "static/media/07.8d8cf47b.jpg";